import { Link } from 'react-router-dom';

export default function ArticleHero() {
  return (
    <section className="relative min-h-[50vh] flex flex-col items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Overhead%20view%20of%20open%20notebook%20with%20handwritten%20shopping%20notes%20and%20spreadsheet%20printouts%20surrounded%20by%20fashion%20lookbook%20pages%2C%20warm%20desk%20lamp%20glow%2C%20organized%20creative%20workspace%20aesthetic%2C%20parchment%20and%20ivory%20tones%20with%20subtle%20sage%20green%20accents%2C%20intellectual%20cozy%20atmosphere%2C%20editorial%20planning%20scene&width=1920&height=800&seq=article-hero-v2-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />

      <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-4xl mx-auto py-20">
        <p className="text-accent-200 text-xs md:text-sm font-label tracking-widest uppercase mb-4">
          / SEO Guide
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          Hipobuy Spreadsheet Ultimate Guide 2026
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto">
          A comprehensive resource covering everything from category navigation to advanced shopping strategies using the Hipobuy Spreadsheet platform.
        </p>
        <div className="mt-6 flex items-center justify-center gap-4 text-white/60 text-sm">
          <span>By Hipobuy Editorial Team</span>
          <span className="w-1 h-1 bg-white/30 rounded-full"></span>
          <span>Updated July 2026</span>
          <span className="w-1 h-1 bg-white/30 rounded-full"></span>
          <span>12 min read</span>
        </div>
      </div>
    </section>
  );
}